export default __webpack_public_path__ + "static/media/logo.d64974fd.webp";